import TabbedView from './components/TabbedView';
import { TabView } from './components/TabbedView/TabbedView';
import HaveList from './tabs/HaveList';
import { useMyCards } from './hooks';
import './MyCards.css';
import WantList from './tabs/WantList';
import CollectionHeader from './components/CollectionHeader/CollectionHeader';
import { useHaveListFetchInfiniteQuery } from 'store/services/collectionList/haveList/haveListApi';
import { useWantListFetchInfiniteQuery } from 'store/services/collectionList/wantList/wantListApi';
import { useMemo } from 'react';
import { AssetUrls } from 'config/assets';

const tabs: TabView[] = [
  {
    title: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <img
          src={AssetUrls.icons.misc.heart}
          alt="Want List"
          style={{ width: '16px', height: '16px' }}
        />
        Want List
      </div>
    ),
    content: <WantList />
  },
  {
    title: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <img
          src={AssetUrls.icons.misc.have}
          alt="Have List"
          style={{ width: '16px', height: '16px' }}
        />
        Have List
      </div>
    ),
    content: <HaveList />
  },
  // { title: 'Wish List', content: <div>Wish List</div> },
];

export const MyCards = () => {
  const { tabIndex, onTabIndexChange } = useMyCards();
  
  // Fetch data for stats calculation
  const { data: haveListData } = useHaveListFetchInfiniteQuery({});
  const { data: wantListData } = useWantListFetchInfiniteQuery({});
  
  // Calculate aggregated stats
  const stats = useMemo(() => {
    const haveListPages = haveListData?.pages || [];
    const wantListPages = wantListData?.pages || [];
    
    // Get total counts from the last page
    const haveListCount = haveListPages.length > 0 ? haveListPages[haveListPages.length - 1].totalCards : 0;
    const wantListCount = wantListPages.length > 0 ? wantListPages[wantListPages.length - 1].totalCards : 0;
    
    // Get total values from backend if available
    // Backend should provide totalValue in the response
    const wantListValue = wantListPages.length > 0 && (wantListPages[wantListPages.length - 1] as any).totalValue 
      ? (wantListPages[wantListPages.length - 1] as any).totalValue 
      : 0;
    
    const haveListValue = haveListPages.length > 0 && (haveListPages[haveListPages.length - 1] as any).totalValue
      ? (haveListPages[haveListPages.length - 1] as any).totalValue
      : 0;
    
    return {
      haveListCount,
      haveListValue,
      wantListCount,
      wantListValue,
    };
  }, [haveListData, wantListData]);

  return (
    <div className="my-cards">
      <h1 className="my-cards-title">My Collection</h1>
      <CollectionHeader stats={stats} />
      <TabbedView
        currentTabIndex={tabIndex}
        setTabIndex={onTabIndexChange}
        tabs={tabs}
      />
    </div>
  );
};
